import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../common/common.model';

import { ModelBase } from './tag.coaching.model';

interface SubBehaviourModel extends ModelBase {
    behaviourId: number;
}

export interface SubBehaviourItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
    behaviourId: number;
}

class SubBehaviourModelTransformer
    implements ModelTransformer<SubBehaviourItem, SubBehaviourModel>
{
    transform(model: SubBehaviourModel): SubBehaviourItem {
        return {
            id: model.id,
            initials: model.text.initials,
            shortName: model.text.shortName,
            name: model.text.name,
            behaviourId: model.behaviourId,
        };
    }
}

export class SubBehaviourModelSetTransformer extends ModelSetTransformer<
    SubBehaviourItem,
    ModelBase
> {
    protected newTransformer(): ModelTransformer<SubBehaviourItem, ModelBase> {
        return new SubBehaviourModelTransformer();
    }
}
